import UserActionTypes from "./user.types";
const INITIAL_STATE = {
  currentUser: null,
  favoriteSpaces: { open: true },
  users: [],
  connectedUsers: [],
  entitlement: "free",
};
const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SET_CURRENT_USER:
      return { ...state, currentUser: action.payload };
    case UserActionTypes.SET_CURRENT_USER_NULL:
      return { ...state, currentUser: null, favoriteSpaces: {}, users: [], connectedUsers: [] };
    case UserActionTypes.SET_USERS:
      return { ...state, users: action.payload };
    case UserActionTypes.SET_CONNECTED_USERS:
      return { ...state, connectedUsers: action.payload };
    case UserActionTypes.SET_OPEN:
      return { ...state, currentUser: { ...state.currentUser, open: action.payload } };
    case UserActionTypes.SET_ENTITLEMENT:
      return { ...state, entitlement: action.payload };
    default:
      return state;
  }
};
export default userReducer;
